import { styled } from '@mui/material';
import { forwardRef } from 'react';
import IconButton from 'shell/components/IconButton';
import Tooltip from 'shell/components/Tooltip';
import { getTooltipProps } from 'utils/helper';

const CustomCheckedIconButton = styled(IconButton)(({ onClick, theme }) => {
    return {
        background: theme.palette.ensightful.success[700],
        '&:hover': {
            background: theme.palette.ensightful.success[800],
        },
        '&:active': {
            background: theme.palette.ensightful.success[900],
        },
        ...(!Boolean(onClick) && {
            '&:hover, &:active': {
                background: theme.palette.ensightful.success[700],
                cursor: 'inherit',
            },
        }),
    };
});

const CustomUncheckedIconButton = styled(IconButton)(({ onClick, theme }) => {
    return {
        border: `1px solid ${theme.palette.ensightful.neutral[700]}`,
        background: 'transparent',
        color: theme.palette.ensightful.neutral[700],
        '&:hover': {
            borderColor: theme.palette.ensightful.neutral[800],
            background: 'transparent',
            color: theme.palette.ensightful.neutral[800],
        },
        '&:active': {
            borderColor: theme.palette.ensightful.neutral[900],
            color: theme.palette.ensightful.neutral[900],
        },
        ...(!Boolean(onClick) && {
            '&:hover, &:active': {
                border: `1px solid ${theme.palette.ensightful.neutral[700]}`,
                color: theme.palette.ensightful.neutral[700],
                cursor: 'inherit',
            },
        }),
    };
});

export default forwardRef(({ checked, size = 'xsmall', onClick, tooltip, ...rest }, ref) => {
    if (tooltip && !tooltip.component) {
        throw new Error(
            `Shell: Invalid tooltip in component CompleteButton. Expected "tooltip.component" to be "string" or "ReactElement", but got "${typeof tooltip.component}" instead.`
        );
    }

    const CompletionButtonComponent = checked ? (
        <CustomCheckedIconButton
            ref={ref}
            {...rest}
            component={onClick ? 'button' : 'div'}
            kind={'checkmark'}
            role={onClick ? 'button' : 'presentation'}
            size={size}
            tabIndex={onClick ? 0 : -1}
            variant={'circle'}
            onClick={onClick}
        />
    ) : (
        <CustomUncheckedIconButton
            ref={ref}
            {...rest}
            component={onClick ? 'button' : 'div'}
            kind={'checkmark'}
            role={onClick ? 'button' : 'presentation'}
            size={size}
            tabIndex={onClick ? 0 : -1}
            variant={'circle'}
            onClick={onClick}
        />
    );

    return tooltip ? (
        <Tooltip {...getTooltipProps(tooltip)}>{CompletionButtonComponent}</Tooltip>
    ) : (
        CompletionButtonComponent
    );
});
